export function IPhonePlaceholder({ label = 'iPhone Screenshot', width = 220, height = 450, src, loading = 'lazy', fetchpriority }) {
  if (src) {
    return (
      <img
        src={src}
        alt={label}
        loading={loading}
        decoding="async"
        fetchpriority={fetchpriority}
        className="mx-auto flex-shrink-0 drop-shadow-2xl"
        style={{ width, height: 'auto', objectFit: 'contain' }}
      />
    );
  }
  return (
    <div className="relative mx-auto flex-shrink-0" style={{ width, height }}>
      {/* Phone shell */}
      <div
        className="absolute inset-0 bg-zinc-800/50 border-2 border-zinc-600 shadow-2xl shadow-black/50"
        style={{ borderRadius: 38 }}
      />
      {/* Screen area */}
      <div
        className="absolute flex flex-col items-center justify-center gap-3 overflow-hidden"
        style={{ inset: 6, borderRadius: 32, backgroundColor: 'rgba(9,9,11,0.9)' }}
      >
        {/* Dynamic Island notch */}
        <div className="absolute top-2 left-1/2 -translate-x-1/2 w-20 h-5 bg-zinc-800 rounded-full z-10" />
        {/* Image placeholder icon */}
        <svg className="w-10 h-10 text-zinc-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
          />
        </svg>
        <p className="text-zinc-500 text-xs text-center px-4 leading-snug">{label}</p>
      </div>
      {/* Side buttons */}
      <div className="absolute right-[-3px] top-24 w-1 h-10 bg-zinc-600 rounded-l" />
      <div className="absolute left-[-3px] top-20 w-1 h-6 bg-zinc-600 rounded-r" />
      <div className="absolute left-[-3px] top-32 w-1 h-6 bg-zinc-600 rounded-r" />
    </div>
  );
}

export function WatchPlaceholder({ label = 'Apple Watch Screenshot', src, loading = 'lazy' }) {
  if (src) {
    return (
      <img
        src={src}
        alt={label}
        loading={loading}
        decoding="async"
        className="flex-shrink-0 mx-auto drop-shadow-2xl"
        style={{ width: 164, height: 'auto', objectFit: 'contain' }}
      />
    );
  }
  return (
    <div className="relative flex-shrink-0 mx-auto" style={{ width: 164, height: 234 }}>
      {/* Band top */}
      <div
        className="absolute left-1/2 -translate-x-1/2 bg-zinc-700"
        style={{ top: 0, width: 50, height: 46, borderRadius: '14px 14px 0 0' }}
      />
      {/* Band bottom */}
      <div
        className="absolute left-1/2 -translate-x-1/2 bg-zinc-700"
        style={{ bottom: 0, width: 50, height: 46, borderRadius: '0 0 14px 14px' }}
      />
      {/* Watch body */}
      <div
        className="absolute border-2 border-zinc-600 bg-zinc-800/50 shadow-xl"
        style={{ left: 22, right: 22, top: 40, bottom: 40, borderRadius: 36 }}
      />
      {/* Screen */}
      <div
        className="absolute flex flex-col items-center justify-center gap-2"
        style={{ left: 28, right: 28, top: 46, bottom: 46, borderRadius: 30, backgroundColor: 'rgba(9,9,11,0.9)' }}
      >
        <svg className="w-6 h-6 text-zinc-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
          />
        </svg>
        <p className="text-zinc-500 text-[9px] text-center px-1 leading-snug">{label}</p>
      </div>
      {/* Digital Crown */}
      <div
        className="absolute bg-zinc-600"
        style={{ right: 19, top: '50%', transform: 'translateY(-50%)', width: 4, height: 28, borderRadius: 4 }}
      />
    </div>
  );
}
